import React from 'react';
import format from 'string-template';
import PropTypes from 'prop-types';

import {
  HabitText,
  ItemContainer,
  TextContainer,
  StatText,
  StyledHabitProgress,
  Container,
} from './styles';
import texts from './texts.json';

const DAYS_PER_WEEK = 7;

const HabitStat = ({
  activity,
}) => {
  const {
    habitData,
  } = activity;

  return (
    <Container>
      {Object.entries(habitData).map(([habitId, habit]) => {
        const {
          completedCount, text, currentStreak = 0, bestStreak = 0,
        } = habit;

        return (
          <ItemContainer key={habitId}>
            <TextContainer>
              <HabitText>
                {text}
              </HabitText>
              <StatText>
                {format(texts.statText, {
                  count: completedCount,
                })}
              </StatText>
            </TextContainer>
            <TextContainer>
              <StatText>
                {format(texts.currentStreak, { count: currentStreak })}
              </StatText>
              <StatText>
                {format(texts.bestStreak, { count: bestStreak })}
              </StatText>
            </TextContainer>
            <StyledHabitProgress
              type="determinate"
              value={completedCount / DAYS_PER_WEEK}
            />
          </ItemContainer>
        );
      })}
    </Container>
  );
};

HabitStat.propTypes = {
  activity: PropTypes.object.isRequired,
};

export default HabitStat;
